var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDragHandle = function SvgDragHandle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 14,
    viewBox: "0 0 9 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#333",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    x: 0.084,
    y: 0.928,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    x: 5.084,
    y: 0.928,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    x: 0.084,
    y: 5.928,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    x: 5.084,
    y: 5.928,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    x: 0.084,
    y: 10.928,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    x: 5.084,
    y: 10.928,
    rx: 1.5
  }))));
};
export default SvgDragHandle;